import * as tslib_1 from "tslib";
import { ImageStretchOptions_$type } from "./ImageStretchOptions";
import { EditorType_$type } from "./EditorType";
import { IgrColumn } from "./igr-column";
import { ImageColumn } from "./ImageColumn";
import { ensureEnum } from "igniteui-react-core";
/**
 * Represents an Image grid column, used to allow the developer to display an image in a cell.
*/
var IgrImageColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrImageColumn, _super);
    function IgrImageColumn(props) {
        return _super.call(this, props) || this;
    }
    IgrImageColumn.prototype.createImplementation = function () {
        return new ImageColumn();
    };
    Object.defineProperty(IgrImageColumn.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrImageColumn.prototype, "imageStretchOption", {
        /**
         * Gets or sets the stretch option to use when rendering images
        */
        get: function () {
            return this.i.jl;
        },
        set: function (v) {
            this.i.jl = ensureEnum(ImageStretchOptions_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrImageColumn.prototype, "editorType", {
        /**
         * Gets or sets the editor type used for editing cells in this column.
        */
        get: function () {
            return this.i.jh;
        },
        set: function (v) {
            this.i.jh = ensureEnum(EditorType_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrImageColumn.prototype, "editorDataSource", {
        /**
         * Gets or sets the ComboBox data source.
        */
        get: function () {
            return this.i.jm;
        },
        set: function (v) {
            this.i.jm = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrImageColumn.prototype, "editorTextField", {
        /**
         * Gets or sets the ComboBox text field.
        */
        get: function () {
            return this.i.jn;
        },
        set: function (v) {
            this.i.jn = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrImageColumn.prototype, "editorValueField", {
        /**
         * Gets or sets the ComboBox value field.
        */
        get: function () {
            return this.i.jg;
        },
        set: function (v) {
            this.i.jg = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrImageColumn;
}(IgrColumn));
export { IgrImageColumn };
//# sourceMappingURL=igr-image-column.js.map
